import { useState, useEffect } from "react";

const PULSE_DURATION = 6100;

export const usePulse = (trigger: boolean) => {
  const [isPulsing, setIsPulsing] = useState(false);

  useEffect(() => {
    if (trigger) {
      setIsPulsing(true);
      const timer = setTimeout(() => setIsPulsing(false), PULSE_DURATION);
      return () => clearTimeout(timer);
    }
  }, [trigger]);

  return isPulsing;
};

export const pulseClassName = (isPulsing: boolean) =>
  isPulsing
    ? "before:absolute before:inset-0 before:rounded-md before:border-2 before:border-orange-500 before:animate-[pulse_6s_ease-in-out] before:pointer-events-none"
    : "";
